import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
export var CLASSNAME = 'Icons-camera';
export var ID = 'icon-camera';
/* eslint-disable max-len */

export var SVGCamera = function SVGCamera() {
  return React.createElement("symbol", {
    id: ID,
    viewBox: "0 0 26 26"
  }, React.createElement("g", {
    fill: "#9C9896"
  }, React.createElement("path", {
    d: "M 25.1875 6.015625 C 25.1875 6.015625 20.609375 6.015625 19.796875 6.015625 C 18.984375 6.015625 18.984375 5.203125 18.984375 5.203125 L 18.984375 3.84375 C 18.984375 3.394531 18.621094 3.03125 18.171875 3.03125 L 7.8125 3.03125 C 7.363281 3.03125 7 3.394531 7 3.84375 L 7 5.203125 C 7 5.203125 7 6.015625 6.1875 6.015625 C 5.375 6.015625 0.8125 6.015625 0.8125 6.015625 C 0.363281 6.015625 0 6.378906 0 6.828125 L 0 22.1875 C 0 22.636719 0.363281 23 0.8125 23 L 25.1875 23 C 25.636719 23 26 22.636719 26 22.1875 L 26 6.828125 C 26 6.378906 25.636719 6.015625 25.1875 6.015625 Z M 23 10.257813 C 22.308594 10.257813 21.742188 9.695313 21.742188 9 C 21.742188 8.304688 22.308594 7.742188 23 7.742188 C 23.691406 7.742188 24.257813 8.304688 24.257813 9 C 24.257813 9.695313 23.691406 10.257813 23 10.257813 Z M 13 21.121094 C 9.070313 21.121094 5.878906 17.933594 5.878906 14 C 5.878906 10.066406 9.070313 6.878906 13 6.878906 C 16.929688 6.878906 20.121094 10.066406 20.121094 14 C 20.121094 17.9375 16.929688 21.121094 13 21.121094 Z M 13 19.457031 C 9.988281 19.457031 7.542969 17.015625 7.542969 14 C 7.542969 10.984375 9.988281 8.542969 13 8.542969 C 16.011719 8.542969 18.457031 10.984375 18.457031 14 C 18.457031 17.015625 16.011719 19.457031 13 19.457031 Z"
  })));
};
/* eslint-disable max-len */

var Camera = function Camera(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGCamera
  });
};

Camera.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default Camera;